import { useQuery } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

const BASE = `${baseUrl}/api/kpi`
const KEY = ['kpi']

// Response types
interface AgentConversation {
  conversationId: string
  userId: string
  firstMessage: string
  totalTokens: number
  totalCost: number
  toolCallCount: number
  model: string
  createdAt: string
  duration: number
}

interface AgentSummary {
  totalConversations: number
  totalTokens: number
  totalCost: number
  avgTokensPerConversation: number
  recentConversations: AgentConversation[]
}

interface TopPrompt {
  label: string
  count: number
  lastUsed: string
}

interface RevisionsSummary {
  totalRevisions: number
  countByType: Record<string, number>
  revenueImpact: number
  mostRevisedOrgs: { pk: string; name: string; count: number }[]
  recentRevisions: { PK: string; SK: string; name: string; semanticVersion: string; versionChangeType: string; updatedAt: string }[]
}

interface StrategySummary {
  totalCreated: number
  totalDeployed: number
  conversionRate: number
  avgPoints: number
  recentStrategies: { clientName: string; status: string; points: number; items: number; createdAt: string }[]
  itemBreakdown: { aiRecommended: number; manual: number }
}

export const useAgentSummary = () =>
  useQuery<AgentSummary>({
    queryKey: [...KEY, 'agent', 'summary'],
    queryFn: () => axios.get<AgentSummary>(`${BASE}/agent/summary`).then(r => r.data),
    staleTime: 60_000,
  })

export const useTopPrompts = () =>
  useQuery<TopPrompt[]>({
    queryKey: [...KEY, 'agent', 'top-prompts'],
    queryFn: () => axios.get<TopPrompt[]>(`${BASE}/agent/top-prompts`).then(r => r.data),
    staleTime: 60_000,
  })

export const useRevisionsSummary = () =>
  useQuery<RevisionsSummary>({
    queryKey: [...KEY, 'revisions', 'summary'],
    queryFn: () => axios.get<RevisionsSummary>(`${BASE}/revisions/summary`).then(r => r.data),
    staleTime: 60_000,
  })

export const useStrategySummary = () =>
  useQuery<StrategySummary>({
    queryKey: [...KEY, 'strategy', 'summary'],
    queryFn: () => axios.get<StrategySummary>(`${BASE}/strategy/summary`).then(r => r.data),
    staleTime: 60_000,
  })

// Track prompt clicks
export const trackPromptClick = (promptLabel: string, userId?: string) =>
  axios.post(`${baseUrl}/aws/agent/track-prompt-click`, { promptLabel, userId }).catch(() => {})
